import React from "react";
import { convertIpfsToUrl } from "../../../utils";

const CollectionMetadataDisplay = ({ metadata }) => {
  if (!metadata) return null;

  return (
    <div className="arch_d_collection-metadata">
      <div className="arch_d_collection-header">
        <h3 className="arch_d_collection-title">{metadata.name}</h3>
      </div>

      {metadata.image && (
        <div className="arch_d_collection-image-container">
          <img
            src={convertIpfsToUrl(metadata.image)}
            alt={metadata.name}
            className="arch_d_collection-image"
          />
        </div>
      )}

      {metadata.description && (
        <div className="arch_d_collection-description">
          <h4 className="arch_d_collection-section-title">Description</h4>
          <div className="arch_d_collection-description-content">
            {metadata.description.split("\n").map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CollectionMetadataDisplay;
